import React from 'react';
import * as Render from '../platformui/Base/Render';
import Chapter from '../platformui/Chapter';
import withViewport from '../platformui/Base/Sensors/viewport';
import withAnchorNavTrigger from '../platformui/Containers/withAnchorNavTrigger';

const ChapterBlock = (props) => {
  return (
    <Chapter
      {...props}
      ContentString={Render.PropertyAsHTML(props.ContentString, 'Content')}
      Heading={Render.Property(props.Heading, 'Heading')}
      Preamble={Render.Property(props.Preamble, 'Preamble')}
    />
  );
};

export default withViewport(withAnchorNavTrigger(ChapterBlock));
